var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldPenTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45 9.44c-.15 0-.3.03-.44.07l-4.99-4.99c.48-.62.44-1.51-.13-2.07l-.78-.78c-.59-.59-1.63-.59-2.23 0l-.78.78c-.56.56-.6 1.45-.12 2.07L4.99 9.51c-.14-.04-.29-.07-.44-.07h-1.1c-.87 0-1.58.71-1.58 1.58v1.1c0 .87.71 1.58 1.58 1.58h1.1c.87 0 1.58-.71 1.58-1.58v-1.1c0-.15-.03-.3-.07-.44l4.99-4.99c.27.21.61.32.95.32.34 0 .68-.12.96-.33l4.99 4.99c-.04.14-.07.29-.07.44v1.1c0 .87.71 1.58 1.58 1.58h1.1c.87 0 1.58-.71 1.58-1.58v-1.1c-.02-.87-.72-1.57-1.59-1.57h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.11 18H9.85l-1.64-1.45c-.95-.78-.95-1.38-.23-2.3l2.89-3.66c.2-.25.43-.42.69-.51.27-.09.56-.09.84 0 .25.09.48.26.69.51l2.89 3.66c.72.91.69 1.48-.23 2.3L14.11 18zM10.7 22c-.92 0-1.61-.75-1.43-1.55l.31-1.39a.6.6 0 0 1 .59-.47h3.65c.28 0 .52.19.59.47l.31 1.39c.2.85-.45 1.55-1.43 1.55H10.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPenTool);
export default __webpack_public_path__ + "static/media/vuesax-bold-pen-tool.a8716221c6d18e3bfaf79a5b582425bc.svg";
export { ForwardRef as ReactComponent };